// extracted by mini-css-extract-plugin
module.exports = {"container":"__5PUh","wrapper":"__6ZJ5","form":"P6jm","bg":"xMFq","bg__left":"uE91","bg__right":"XkVQ"};